import { Image } from "@heroui/react";
import mashKingRunning from "../assets/img/mashking/running.png";

export const Loading = () => {
  return (
    <Image
      className="animate-bounce ease-soft-spring"
      width={150}
      src={mashKingRunning}
      alt="Mash King Running"
    />
  );
};
